export default __webpack_public_path__ + "static/089-9cf14660c3ab1acf56f77118189da219.jpg";